import { FC } from 'react';
import { Button } from '@mui/material';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';

interface ChartSortByActionButtonProps {
  onClick: () => void;
  order: 'ASC' | 'DESC';
}

export const SortByActionButton: FC<ChartSortByActionButtonProps> = ({
  onClick,
  order,
}) => {
  const ButtonIcon = order === 'ASC' ? ArrowDownward : ArrowUpward;

  return (
    <Button
      onClick={onClick}
      sx={{
        color: theme => theme.palette.common.black,
        fontSize: 14,
        textTransform: 'capitalize',
      }}
      endIcon={<ButtonIcon color='disabled' sx={{ width: 24, height: 24 }} />}
      variant='text'
    >
      Sort by
    </Button>
  );
};
